import { createFileRoute } from '@tanstack/react-router';
import { SearchOverlay } from '@/components/Search/SearchOverlay';

export const Route = createFileRoute('/search')({
  component: () => <SearchOverlay />,
});
